var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlaneFill = function SvgIconPlaneFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.667 7.456 6.666 4.211v1.667l-6.666-2.105v4.466l2.5 1.389v1.25l-3.75-.834-3.75.834v-1.25l2.5-1.39v-4.466L2.5 13.334v-1.667l6.667-4.21v-4.54a1.25 1.25 0 1 1 2.5 0v4.54Z",
    fill: "#F2A72D"
  })));
};
export default SvgIconPlaneFill;